import * as notificationContents from '../app/agora/routes/notificationPanel/notificationContents';
import {
  NOTIFICATIONCONTENTTYPE_BODY,
  NOTIFICATIONCONTENTTYPE_FOOTER,
  NOTIFICATIONCONTENTTYPE_HEADER,
  NOTIFICATIONCONTENTTYPE_NONE,
  NOTIFICATIONCONTENTTYPE_SUBJECT,
} from '../constants/api';

export const resolveNotificationContent = (notificationContentType) => {
  const componentName = mapTypeToComponentName(notificationContentType);
  return componentName && notificationContents[componentName];
};

const mapTypeToComponentName = (type) => {
  switch (type) {
    case NOTIFICATIONCONTENTTYPE_SUBJECT:
      return 'NotificationSubject';
    case NOTIFICATIONCONTENTTYPE_HEADER:
      return 'NotificationHeader';
    case NOTIFICATIONCONTENTTYPE_BODY:
      return 'NotificationBody';
    case NOTIFICATIONCONTENTTYPE_FOOTER:
      return 'NotificationFooter';
    case NOTIFICATIONCONTENTTYPE_NONE:
    default:
      return null;
  }
};
